import { render } from "./MainSection.vue?vue&type=template&id=eb007360&scoped=true"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"

import "./MainSection.vue?vue&type=style&index=0&id=eb007360&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb007360"]])

export default __exports__